module.exports = function(app) {
	'use strict'
	app.directive('notificationCenterDir',notificationCenterDir);
	notificationCenterDir.$inject=['$timeout'];
	function notificationCenterDir($timeout) {
		return {
			restrict: 'E',
            scope:{
                obj:"=",
            },
            replace:true,
			template: require('./partial/notificationCenter.html'),
			link: function(scope, ele, $attrs, ctrl) {
				scope.closeNotification = function(id) {
                    var index = -1;
                    for(var i= 0;i<scope.obj.notifications.length;i++) {
                        if(id == scope.obj.notifications[i].id) {
                            index = i
                            break
                        }
                    }
                    if(index!==-1) {
                        scope.obj.notifications.splice(index,1)
                    }
                }
                //expose closeNotification func to parent controller
                scope.obj.notificationsDeleteFunction = scope.closeNotification
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/notificationCenter/notificationCenterDirective.js
// module id = 444
// module chunks = 0